import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  personImage: {
    width: 85,
    height: 85,
    objectFit: 'cover',
    border: `1px solid ${theme.palette.primary.dark}`,
    borderRadius: 10,
    boxShadow: 'px 3px 6px #00000029'
  },
  withoutPersonImage: {
    width: 85,
    height: 85,
    objectFit: 'cover',
    borderRadius: 10,
    background: '#CECECE 0% 0% no-repeat padding-box',
    boxShadow: '0px 3px 6px #00000029',
    border: '1px solid #EEEEEE'
  }
}));
